import {Component, Input, OnInit} from '@angular/core';
import {FormControl, UntypedFormControl, ValidatorFn, Validators} from '@angular/forms';
import {GetInputAlertOptions} from '../../../../shared-utilities/services-old/standard-alerts.service';
import {ModalControllerService} from '../../../../shared/shared-services/overlay/modal-controller.service';

@Component({
  selector: 'app-basic-input',
  templateUrl: './basic-input.component.html',
  styleUrls: ['./basic-input.component.scss'],
  standalone: false,
})
export class BasicInputComponent implements OnInit {

  @Input() options: GetInputAlertOptions;

  formControl: UntypedFormControl;

  constructor(
    private modalController: ModalControllerService,
  ) {
  }

  ngOnInit(): void {
    const validators: ValidatorFn[] = [Validators.required];

    if (this.options.pattern) {
      validators.push(Validators.pattern(this.options.pattern));
    }

    if (this.options.validators) {
      validators.push(...this.options.validators);
    }

    if (this.options.type === 'number') {
      this.formControl = new FormControl<number>(null, validators);
    } else {
      this.formControl = new FormControl<string>(null, validators);
    }
  }

  async submit(): Promise<void> {
    await this.modalController.dismiss(this.formControl.value).then();
  }

  async cancel(): Promise<void> {
    await this.modalController.dismiss(null).then();
  }
}
